import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { prodURL } from "../utils/common";

function Footer() {
  const { t } = useTranslation();
  return (
    <>
      <footer id="footer" className="footer">
        <div className="footer-content px-5">
          <div className="container-fluid">
            <div className="row">
              <div
                className="col-lg-3 col-md-6 col-sm-6 footer-links aos-init aos-animate"
                data-aos="fade-down"
                data-aos-delay={400}
              >
                <h4 className="fontSizeClass">{t("Useful Links")}</h4>
                <ul>
                  {/* <li>
              <i className="bi bi-chevron-right" />
              <a className="fontSizeClass" href={`${mainURL}/KMCPortal/jsp/DocumentDetails.jsp`} target="_blank">{t("M.I.C Agenda & Resolution")}</a>
            </li> */}
                  <li>
                    <i className="bi bi-chevron-right" />
                    <Link className="fontSizeClass" to="/KMC_Recruitments">
                      {t("Recruitment / Result/Training")}
                    </Link>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />
                    <Link className="fontSizeClass" to="/DownloadableForms">
                      {t("Downloadable_Forms")}
                    </Link>
                  </li>
                  {/* <li>
                    <i className="bi bi-chevron-right" />
                    <a
                      className="fontSizeClass"
                      onClick={(e) => fileDownload("868")}
                    >
                      {t("ist_of_Pay_&_Use_Toilets")}
                    </a>
                  </li> */}
                  <li className="drop-footer" style={{ display: "block" }}>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm footer-more"
                      data-toggle="collapse"
                      data-target="#footer2"
                    >
                      {t("More")}
                    </button>
                    <div id="footer2" className="collapse mt-4">
                      <li>
                        <i className="bi bi-chevron-right" />
                        <Link className="fontSizeClass" to="/Procedure">
                          {t("Grievance_Redressal")}
                        </Link>
                      </li>
                      <li>
                        <i className="bi bi-chevron-right" />
                        <a
                          className="fontSizeClass"
                          href="https://www.kmcgov.in/KMCPortal/jsp/EncumbranceCertificate.jsp"
                          target="_blank"
                        >
                          {t("Encumbrance Certificate")}
                        </a>
                      </li>
                    </div>
                  </li>
                </ul>
              </div>

              <div
                className="col-lg-2 col-md-6 col-sm-6 footer-links aos-init aos-animate"
                data-aos="fade-down"
                data-aos-delay={400}
              >
                <h4 className="fontSizeClass">{t("Other Links")}s</h4>
                <ul>
                  <li>
                    <i className="bi bi-chevron-right" />
                    <a href={`${prodURL}/tender-details/circularnotices`}>
                      {" "}
                      {t("Circulars")}{" "}
                    </a>
                    {/* <Link className="fontSizeClass" to="/Municipal_secretary_circular">
                      {t("Circulars")}
                    </Link> */}
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />
                    <Link className="fontSizeClass" to="/SiteMap"> {t("Site map")}</Link>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />
                    <Link className="fontSizeClass" to="/Disclaimer"> {t("Disclaimer")}</Link>
                  </li>
                  <li className="drop-footer" style={{ display: "block" }}>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm footer-more"
                      data-toggle="collapse"
                      data-target="#footer1">
                      {t("More")}
                    </button>
                    <div id="footer1" className="collapse mt-4">
                      <li>
                        <i className="bi bi-chevron-right" />
                        <a
                          className="fontSizeClass"
                          href={`https://www.kmcgov.in/KMCPortal/jsp/PortalFeedback.jsp`}
                          target="_blank"
                        >
                          {t("Feedback")}
                        </a>
                      </li>
                      <li>
                        <i className="bi bi-chevron-right" />
                        <Link className="fontSizeClass" to="/Faqs">
                          {t("FAQ")}
                        </Link>
                      </li>
                      <li>
                        <i className="bi bi-chevron-right" />
                        <Link className="fontSizeClass" to="/Contact_Us_Home">
                          {t("Contact Us")}
                        </Link>
                      </li>
                      <li>
                        <i className="bi bi-chevron-right" />
                        <Link className="fontSizeClass" to="/Dashboard">
                          {t("EODB Dashboard-Online")} <br /> {t("Services")}
                        </Link>
                      </li>
                    </div>
                  </li>
                </ul>
              </div>
              <div
                className="col-lg-4 col-md-6 col-sm-6 footer-links aos-init aos-animate" 
                data-aos="fade-down" data-aos-delay={400} >
                <h4 className="fontSizeClass">{t("Useful Information")}</h4>
                <p className="fontSizeClass d-flex">
                  <i className="bi bi-map-fill" style={{ marginRight: "10px" }}/>
                  <span className="fontSizeClass">
                  Head Office - 5, S.N.Banerjee Road,<br/> Kolkata 700 013, India
                   </span>
                </p>
                <p className="fontSizeClass d-flex">
                  <i className="bi bi-phone-fill" style={{ marginRight: "10px" }}/>
                  <span className="fontSizeClass">
                    {t("KMC Working Days")} <br />
                    {t( "Mon-Fri : 10:30 AM to 5:00 PM ")} <br />  {t( "Sat : 10:30 AM to 2:30 PM")}                   
                    <br />
                    {t("Ph")} : 2226-9909 , 18003453375 {t("(Toll Free)")}
                  </span>
                </p>
              </div>
              <div
                className="col-lg-3 col-md-6 col-sm-6 footer-newsletter aos-init aos-animate"
                data-aos="fade-down" data-aos-delay={400} >
                {/* <form action="" method="post">
                  <input type="email" name="email" />
                  <input type="submit" defaultValue="Subscribe" />
                </form> */}
                <p className="fontSizeClass">
                  <Link className="fontSizeClass" to="">
                    {t("Visitor No")} : 1000
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-legal text-center">
          <div className="container d-flex flex-lg-row justify-content-center justify-content-lg-between align-items-center">
            <div className="align-items-center align-items-lg-start">
              <div className="credits">
                {t("Designed by")} :
                <Link className="fontSizeClass" to="">
                  {t("Kolkata Municipal Corporation")}@2026
                </Link>
              </div>
            </div>
            {/* <div className="social-links order-first order-lg-last mb-3 mb-lg-0">
          <Link to='/portal' className="twitter fontSizeClass">
            <i className="bi bi-twitter" />
          </Link>
          <Link to='/portal' className="facebook fontSizeClass">
            <i className="bi bi-facebook" />
          </Link>
        </div> */}
          </div>
        </div>
      </footer>

      <Link
        to="/portal"
        className="scroll-top d-flex align-items-center justify-content-center fontSizeClass"
      >
        <i className="bi bi-arrow-up-short fontSizeClass" />
      </Link>
    </>
  );
}

export default Footer;
